import React, { useEffect } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { mypageHeader, mypageHeaderTitle } from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import PublisherIssueList from '../../uiParts/PublisherIssueList';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  mypageHeader,
  mypageHeaderTitle,
  sideBar: {
    '@media screen and (max-width:960px)': {
      display: 'block'
    },
    display: 'flex'
  }
};

const PublisherMypageIssueList: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.publisher.mypageIssue');
  });

  return (
    <>
      <Typography component="div" sx={styles.sideBar}>
        <Sidebar screenType={screenType.publisher} />
        <Typography
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            position: 'static',
            width: '100%'
          }}
        >
          <Typography sx={styles.mypageHeader} component="div">
            <Typography sx={styles.mypageHeaderTitle}>
              {t('given.givenlist')}
            </Typography>
          </Typography>
          <Typography component="div">
            <PublisherIssueList />
          </Typography>
        </Typography>
      </Typography>
    </>
  );
};

export default PublisherMypageIssueList;
